import TableResizeBody from "./Body";
import TableResizeHeader from "./Header";
import TableResizeWrapper from "./Wrapper";
import { TableProvider } from "./context";

export default function DefaultTableResize(props) {
  return <TableProvider {...props}>
    <TableResizeContent {...props} />
  </TableProvider>
}

function TableResizeContent({ columns, data, noDataIndication, rowClassName, keyField, className = '', rowWrapper, footer, sticky = true }) {
  return <TableResizeWrapper
    columns={columns}
    data={data}
    noDataIndication={noDataIndication}
    className={className}
  >
    <TableResizeHeader sticky={sticky} />
    <TableResizeBody
      columns={columns}
      data={data}
      rowClassName={rowClassName}
      keyField={keyField}
      rowWrapper={rowWrapper}
    />
    {footer}
  </TableResizeWrapper>
}

